<template>
  <section class="hero-section">
    <div class="overlay">
      <div class="content">
        <h1>GELECEĞİ ŞEKİLLENDİREN <br /> ELEKTRONİK ÇÖZÜMLER</h1>
        <p>
          İntek Electronics olarak, yerli ve özgün kontrol kartı tasarımlarımızla
          endüstriyel otomasyona yenilikçi çözümler sunuyoruz.
        </p>
        <router-link to="/kurumsal">
          <button>Bizi Tanıyın</button>
        </router-link>
      </div>

      <!-- İKONLAR -->
      <div class="icon-wrapper-container">
        <ul class="services-list">
          <li
            v-for="service in services"
            :key="service.title"
            class="service-item"
          >
            <article>
              <router-link
                :to="service.path"
                class="icon-wrapper"
                :aria-label="service.aria"
              >
                <span class="hover-text">{{ service.title }}</span>
                <img
                  :src="service.img"
                  :alt="service.alt"
                  class="placeholder-img"
                  loading="lazy"
                />
              </router-link>
            </article>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeHeroAndServices',
  data() {
    return {
      services: [
        {
          path: '/kumanda-kontrol-kartlari',
          aria: 'Kontrol Kartları sayfasına git',
          img: '/images/gif/8.png',
          alt: 'İntek Electronic kontrol kartları',
          title: 'Kontrol Kartları'
        },
        {
          path: '/sensor-uretimi',
          aria: 'Isı Sensörleri sayfasına git',
          img: '/images/gif/6.png',
          alt: 'İntek Electronic ısı sensörleri',
          title: 'Isı Sensörleri'
        },
        {
          path: '/kablo-gruplama',
          aria: 'Kablo Gruplama çözümleri sayfasına git',
          img: '/images/gif/7.png',
          alt: 'İntek Electronic kablo gruplama',
          title: 'Kablo Grupları'
        }
      ]
    }
  }
}
</script>

<style scoped>
.hero-section {
  height: 100vh;
  background-image: url('@/assets/kart-tasarim.png');
  background-size: cover;
  background-position: center;
  position: relative;
  padding-top: 70px;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay {
  background-color: rgba(0, 0, 0, 0.55);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 1rem;
  text-align: center;
}

.content {
  color: white;
  max-width: 1000px;
  padding: 1rem;
  margin-bottom: 50px;
  margin-top:110px;
}

.content h1 {
  font-size: 3.5rem;
  font-weight: 200;
  line-height: 1.3;
  margin-bottom: 1rem;
}

.content p {
  font-size: 1.4rem;
  line-height: 1.7;
}

button {
  margin-top: 20px;
  padding: 14px 28px;
  font-size: 16px;
  background-color: transparent;
  border: 2px solid white;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
}
button:hover {
  background-color: white;
  color: black;
}

/* İKONLAR */
.icon-wrapper-container {
  width: 100%;
 
  padding: 30px 0px;
  scrollbar-width: none;       /* Firefox */
  -ms-overflow-style: none;
}
.icon-wrapper-container::-webkit-scrollbar {
  display: none;               /* Chrome, Safari, Opera */
}
.services-list {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 25px;
  list-style: none;
  padding: 0;
  margin: 0 auto;
}

.service-item {
  position: relative;
  flex: 0 0 auto;
  width: 90px;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.service-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  z-index: 0;
  transition: background 0.3s ease;
}

.placeholder-img {
  position: relative;
  z-index: 1;
  max-width: 70px;
  max-height: 70px;
  filter: grayscale(100%) brightness(1.2);
  transition: filter 0.3s ease;
}
.service-item:hover::before {
  background: #ff914d;
}
.service-item:hover .placeholder-img {
  filter: none;
}

/* Hover yazısı */
.hover-text {
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 13px;
  font-weight: 600;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: 3;
  white-space: nowrap;
}
.service-item:hover .hover-text {
  opacity: 1;
  transform: translateX(-50%) translateY(-10px);
}

.icon-wrapper {
  display: inline-block;
  position: relative;
}

/* Responsive */
@media (max-width: 991px) {
  .content h1 {
    font-size: 2.5rem;
  }
  .content p {
    font-size: 1.2rem;
  }
  button {
    padding: 12px 24px;
    font-size: 15px;
  }
}

@media (max-width: 767px) {
  .content h1 {
    font-size: 2rem;
  }
  .content p {
    display: none;
  }
  button {
    display: none;
  }
}
</style>
